"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var embed_react_1 = require("@typeform/embed-react");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var StyledButton = (0, styles_1.styled)(Button_1.default)(function () { return ({
    '& svg.fa-megaphone': {
        transform: 'rotate(342deg)',
    },
}); });
var StyledPopupButton = (0, styles_1.styled)(embed_react_1.PopupButton)(function () { return ({ display: 'none' }); });
var TypeformPopupButton = function (_a) {
    var typeFormID = _a.typeFormID, icon = _a.icon, children = _a.children, hidden = _a.hidden, rest = __rest(_a, ["typeFormID", "icon", "children", "hidden"]);
    var onClick = function (e) {
        var _a;
        return ((_a = e.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".pub-".concat(typeFormID))).click();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledPopupButton, __assign({ className: "pub-".concat(typeFormID), id: typeFormID, hideFooter: true, hideHeaders: true, hidden: hidden }, { children: "Nothing" })), (0, jsx_runtime_1.jsx)(StyledButton, __assign({ color: "neutral", icon: icon }, rest, { onClick: onClick }, { children: children }))] }));
};
exports.default = (0, DefaultPropsHoC_1.default)(TypeformPopupButton, {
    variant: 'contained',
    type: 'button',
});
